import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { EXTERNAL_LINKS } from '../../../app-config';

import BuildOnHatImage from '../../../assets/buildOnHat.svg';
import TechStackImage from '../../../assets/TechStack.svg';
import ArchitectureImage from '../../../assets/architecture.svg';
import { LandingPageDetailsStringIcon } from '../../../interfaces/details';
import usePageStyles from '../styles';

const ABOUT_HAT_PANELS: LandingPageDetailsStringIcon[] = [
  {
    Icon: BuildOnHatImage,
    title: 'Why build on HAT?',
    details: [
      'Out-of-the-box authentication',
      'Build what cannot be built',
      'Customer acquisition support',
    ],
    link: EXTERNAL_LINKS.dataswiftDocs,
  },
  {
    Icon: TechStackImage,
    title: 'Technology stack',
    details: [
      'HAT micro-servers',
      'Web / iOS / Android dashboards',
      'DataPlugs for data acquisition',
      'Support microservices',
    ],
    link: EXTERNAL_LINKS.dataswiftStack,
  },
  {
    Icon: ArchitectureImage,
    title: 'HAT architecture',
    details: [
      'Architecture that scales: decentralised data with centralised services',
      'Open-source transparent core code',
      'Microservice-based approach',
    ],
    link: EXTERNAL_LINKS.dataswiftArchitecture,
  },
];

const AboutHatPanel: React.FC<LandingPageDetailsStringIcon> = ({
  title,
  details,
  link,
  Icon,
  index,
}) => (
  <Grid
    container
    direction={index && index % 2 !== 0 ? 'row-reverse' : 'row'}
    justifyContent="center"
    alignItems="center"
  >
    <Grid item>
      <img src={Icon} alt={title} />
    </Grid>
    <Grid item className="about-details">
      <div className="text-subtitle text-primary">{title}</div>

      <ul>
        {details.map((detail) => (
          <li key={detail}>
            <Typography color="textPrimary">{detail}</Typography>
          </li>
        ))}
      </ul>

      <div className="link-row">
        <i className="chevron" />
        <a href={link} target="_blank" rel="noopener noreferrer">
          <Typography color="textPrimary">
            <b>Read More</b>
          </Typography>
        </a>
      </div>
    </Grid>
  </Grid>
);

const AboutHat: React.FC = () => {
  const pageClasses = usePageStyles();

  return (
    <Grid container className={`${pageClasses.section} ${pageClasses.section1}`} wrap="wrap">
      <Grid container justifyContent="center">
        <Grid item>
          <Typography color="textPrimary" variant="h1">
            About HAT
          </Typography>
        </Grid>
      </Grid>

      {ABOUT_HAT_PANELS.map((panel, index) => (
        <AboutHatPanel key={panel.title} {...panel} index={index} />
      ))}
    </Grid>
  );
};

export default AboutHat;
